// extracted by mini-css-extract-plugin
module.exports = {"container":"DeleteBusySpan_container__Gntv2","busyPeople":"DeleteBusySpan_busyPeople__2rjHF","delete":"DeleteBusySpan_delete__37S8D"};